import { Button, Card, Input, Space, Typography, message } from 'antd';
import { CopyOutlined, LinkOutlined } from '@ant-design/icons';
import { ReferralLinkData } from '../../types/engagement.types';

const { Text } = Typography;

interface EngagementReferralLinkCardProps {
  referralLink: ReferralLinkData;
}

export const EngagementReferralLinkCard = ({ referralLink }: EngagementReferralLinkCardProps) => {
  const copyLink = async () => {
    await navigator.clipboard.writeText(referralLink.url);
    message.success('Link de indicação copiado!');
  };

  return (
    <Card title="Seu link de indicação" style={{ marginBottom: 24 }}>
      <Space direction="vertical" size={12} style={{ width: '100%' }}>
        <Text type="secondary">Compartilhe este link com novos participantes para acumular pontos.</Text>
        <Input value={referralLink.url} prefix={<LinkOutlined />} readOnly />
        <Button icon={<CopyOutlined />} onClick={copyLink}>
          Copiar link
        </Button>
      </Space>
    </Card>
  );
};

export default EngagementReferralLinkCard;
